export default "__VITE_ASSET__DQJN5PZm__"